// Module
var code = "<audio autoplay muted/>";
// Exports
export default code;